import { Card, Icon } from "@/components/atoms";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../../common/DetailField";

interface VehicleCategoryCardProps {
  booking: BookingDetails;
}

export const VehicleCategoryCard = ({ booking }: VehicleCategoryCardProps) => {
  const { vehicleCategory } = booking;

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="Car" size="lg" className="text-neutral-dark-gray" />}
        label="Vehicle Category"
        value={vehicleCategory.name}
      />
    </Card>
  );
};
